function create({page, prev, next}) {
  let obj = {
    page,
    prev,
    next
  }
  obj.url = obj.page.url
  return obj
}

class Linked {
  constructor() {
    this.curr = null
  }
  add(page) {
    let last = this.curr
    let obj = create({
      page: page,
      prev: last,
      next: null,
    })
    if (last) {
      let next = last.next
      while (next) {
        next.page.remove()
        next = next.next
      }
      last.next = obj
    }
    this.curr = obj
    return obj
  }
  back() {
    let prev = this.curr.prev
    if (!prev) return
    this.curr = prev
    return prev
  }
  replace(page) {
    let curr = this.curr || {}
    let prev = curr.prev
    let obj = create({
      page,
      prev,
      next: curr.next
    })
    if (prev) prev.next = obj
    this.curr = obj
    return obj
  }
  reset(page) {
    this.remove()
    this.curr = create({
      page: page,
      prev: null,
      next: null
    })
    return this.curr
  }
  remove() {
    if (!this.curr) return
    let {prev, next} = this.curr
    if (prev) {
      do {
        prev.page.remove()
        prev = prev.prev
      } while (prev)
    }
    if (next) {
      do {
        next.page.remove()
        next = next.next
      } while (next)
    }
  }
}

export default new Linked()
